<template>
  <vs-row vs-type="flex" vs-align="center" vs-justify="center" class="vh-100">
    <vs-col vs-w="4">
      <vs-card>
        <div slot="header">
          <h2>Beregszászi Étterem Admin</h2>
          <h3>Bejelentkezés</h3>
        </div>
        <div>
          <form>
            <vs-row vs-justify="center">
              <span>{{ errorMsg }}</span>
            </vs-row>
            <vs-row>
              <vs-input autofocus autocomplete="username" label-placeholder="Felhasználó név"
                        v-model="username"></vs-input>
            </vs-row>
            <vs-row>
              <vs-input autocomplete="current-password" label-placeholder="Jelszó" v-model="password"
                        type="password"></vs-input>
            </vs-row>
            <vs-row vs-justify="center">
              <vs-button @click="login()" color="primary">Bejelentkezés</vs-button>
            </vs-row>
          </form>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "login",
  data() {
    return {
      username: '',
      password: '',
      errorMsg: ' '
    }
  },
  methods: {
    login() {
      this.errorMsg = '';
      let self = this;
      let data = {username: this.username, password: this.password}
      axiosInstance
          .post('admin/authController.php', data, { withCredentials: true})
          .then((resp) => {
                if (resp.data.status === 'SUCCESS') {
                  self.$store.commit('loginUser');
                  this.$router.push({name: 'orders'});
                } else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: 'Sikertelen bejelentkezés',
                    color: 'danger',
                    icon: 'error'
                  });
                  self.errorMsg = 'Hibás név vagy jelszó.'
                }
              }
          )
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    }
  }
}
</script>

<style scoped>
.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.vs-button {
  width: 40%;
  margin: 2px 10px;
  display: inline;
}
</style>